import React, { ReactElement, useEffect, useState } from "react";
import styles from "./styles.module.scss"
import { Box, Menu } from "@mui/material";
import LanguageSwitch from "../LanguageSwitch";
import OddsType from "../OddsType";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import FontAwesomeIcon from "components/shared/FontAwesomeIcon";
import { Translate } from "react-redux-i18n";
import { toggleDesktopLayout } from "redux/layoutToggle/layoutToggleSlice";
import { useWindowSize } from "services/utils";

export default function Settings(): ReactElement {
  const [width] = useWindowSize()
  const dispatch = useAppDispatch()
  const toggleDesktop = process.env.REACT_APP_TOGGLE_DESKTOP as string;
  const isDesktopLayout = useAppSelector(state => state.layoutToggle.isDesktopLayout)
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false)
  const [menuAnchor, setMenuAnchor] = useState<(EventTarget & HTMLDivElement) | null>(null)
  const images = require.context(
    "assets/images/header",
    true,
    /\.(png|ico|svg|jpg|gif)$/
  );

  const handleOpen = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    setMenuAnchor(event.currentTarget);
    setIsMenuOpen(true)
  }

  const handleClose = () => {
    setMenuAnchor(null)
    setIsMenuOpen(false)
  }

  const handleDesktopLayout = () => {
    dispatch(toggleDesktopLayout({ status: true }))
  }

  const handleMobileToggle = () => {
    dispatch(toggleDesktopLayout({ status: false }))
  }

  useEffect(() => {
    (!isDesktopLayout && width < 900) && setMenuAnchor(null);
  }, [width, isDesktopLayout]);

  return (
    <Box className={styles.settingsContainer}>
      <Box onClick={(e) => handleOpen(e)} className={styles.settingsButton}>
        <img
          src={images(`./gear.svg`).default}
          alt=""
          className={styles.gameLinkImg}
        />
      </Box>
      <Menu
        anchorEl={menuAnchor}
        open={isMenuOpen}
        onClose={handleClose}
        disableAutoFocusItem
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        PaperProps={isDesktopLayout ? { className: styles.paper } : {}}
      >
        <LanguageSwitch handleClose={handleClose} />
        {process.env.REACT_APP_HIDE_LIVE_SPORT !== "true" &&
          <OddsType handleClose={handleClose} />
        }
        {(width <= 1250 || isDesktopLayout) &&
          <>
            {toggleDesktop == "true" &&
              isDesktopLayout ?
              <Box
                onClick={() => {
                  handleClose()
                  handleMobileToggle();
                }}
                className={styles.menuItem}
              >
                <Box className={styles.menuImage}>
                  <FontAwesomeIcon type="fal" name="mobile" margin={1} />
                </Box>
                <Translate value="layout.showMobile" />
              </Box>
              :
              <Box
                component="button"
                onClick={() => {
                  handleClose()
                  handleDesktopLayout()
                }}
                className={styles.menuItem}
              >
                <Box className={styles.menuImage}>
                  <FontAwesomeIcon
                    type="fal"
                    name="desktop"
                    margin={1}
                    width="20px"
                  />
                </Box>
                <Translate value="layout.showDesktop" />
              </Box>
            }
          </>
        }
      </Menu>
    </Box>
  )
}